import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetChatSettings as GetChatSettingsQuery} from 'nutshell-graphql-types';

import GET_CHAT_SETTINGS from '../queries/get-chat-settings.graphql';

export const useGetChatSettings = () => {
    const {data, error, loading, refetch} = useQuery<GetChatSettingsQuery, Record<any, any>>(
        GET_CHAT_SETTINGS,
        {}
    );

    const {chatSettings} = makeDataDangerous(data);

    return {
        chatSettings,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
        refetch,
    };
};
